import { render, staticRenderFns } from "./RulesEditForm.vue?vue&type=template&id=9efb8090"
import script from "./RulesEditForm.vue?vue&type=script&lang=js"
export * from "./RulesEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports